export default __webpack_public_path__ + "static/media/bg8.2c89438b.jpg";